import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import CustomInputText from "../../components/forms/CustomInputText";
import CustomCheckbox from "../../components/forms/CustomCheckbox";
import { Formik } from "formik";
import * as Yup from "yup";

interface TranscriptOfRecordsDialogProps {
  visible: boolean;
  onHide: () => void;
  onGenerate: (values: TranscriptFormValues) => void;
}

interface TranscriptFormValues {
  documentNumber: string;
  documentNote: string;
  isEnglish: boolean;
}

const validationSchema = Yup.object().shape({
  documentNumber: Yup.string().required("Полето е задължително"),
});

const initialValues: TranscriptFormValues = {
  documentNumber: "",
  documentNote: "",
  isEnglish: false,
};

const TranscriptOfRecordsDialog: React.FC<TranscriptOfRecordsDialogProps> = ({
  visible,
  onHide,
  onGenerate,
}) => {
  const [loading, setLoading] = useState(false);

  const handleGenerate = async (values: TranscriptFormValues) => {
    setLoading(true);
    try {
      await onGenerate(values);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        handleGenerate(values);
      }}
    >
      {({ handleSubmit }) => (
        <Dialog
          header="Генериране на академическа справка"
          visible={visible}
          style={{ width: "450px" }}
          modal
          footer={(
            <>
              <Button label="Отказ" icon="pi pi-times" outlined onClick={onHide} disabled={loading} />
              <Button 
                label="Генериране" 
                icon="pi pi-check" 
                onClick={() => handleSubmit()}
                loading={loading}
              />
            </>
          )}
          onHide={onHide}
        >
          <div className="flex flex-column gap-2">
            <CustomInputText
              id="documentNumber"
              label="Номер на документа"
              required
            />
            <CustomInputText
              id="documentNote" 
              label="Бележка"
              type="multiline"
            />
            <CustomCheckbox
              id="isEnglish"
              label="На английски език"
            />
          </div>
        </Dialog>
      )}
    </Formik>
  );
};

export default TranscriptOfRecordsDialog; 